import { Routes } from '@angular/router';
import { SurveysComponent } from './surveys/surveys.component';
import { OrganizationComponent } from './organization/organization.component';
import { MonitoringComponent } from './monitoring/monitoring.component';
import { ORG_ROUTES } from './organization/organization.routes';
import { SURVEYS_ROUTES } from './surveys/surveys.routes';

export const SURVEY_ROUTES: Routes = [
    { path: 'encuestas', component: SurveysComponent, children: SURVEYS_ROUTES },
    { path: 'org', component: OrganizationComponent, children: ORG_ROUTES },
    { path: 'monitoreo', component: MonitoringComponent },
    { path: '**', pathMatch: 'full', redirectTo: 'encuestas'}
];